//综合查询
export default [
    {
        code: 'comprehensiveQuery',
        name: '综合查询',
        icon: 'el-icon-s-home',
        parentKey: '',
        selfFlg: 'query',
        children: [
            {
                code: 'tabelQuery',
                name: 'tob宽表查询',
                parentKey: 'comprehensiveQuery',
                selfFlg: 'wide_table'
            },
            {
                code: 'tabelQuerytoC',
                name: 'toc宽表查询',
                parentKey: 'comprehensiveQuery',
                selfFlg: 'wide_table_c'
            },
            // {
            //     code: 'tableQueryOperate',
            //     name: '运营新增宽表',
            //     parentKey: 'comprehensiveQuery',
            //     selfFlg: 'run'
            // },
            {
                code: 'exportFileManagement',
                name: '导出文件管理',
                parentKey: 'comprehensiveQuery',
                selfFlg: 'export_file'
            }
        ]
    }
];
